import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8 1.23077C4.26146 1.23077 1.23077 4.26146 1.23077 8C1.23077 11.7386 4.26146 14.7692 8 14.7692C11.7386 14.7692 14.7692 11.7386 14.7692 8C14.7692 4.26146 11.7386 1.23077 8 1.23077ZM0 8C0 3.58172 3.58172 0 8 0C12.4182 0 16 3.58172 16 8C16 12.4182 12.4182 16 8 16C3.58172 16 0 12.4182 0 8Z",
  fill: "#9CA3AF"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.99817 11.4865C8.33801 11.4865 8.61353 11.211 8.61353 10.8711V7.58907C8.61353 7.24915 8.33801 6.97363 7.99817 6.97363C7.65833 6.97363 7.38281 7.24915 7.38281 7.58907V10.8711C7.38281 11.211 7.65833 11.4865 7.99817 11.4865Z",
  fill: "#9CA3AF"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.82065 5.12813C8.82065 4.67497 8.45329 4.30762 8.00017 4.30762C7.54705 4.30762 7.17969 4.67497 7.17969 5.12813C7.17969 5.58128 7.54705 5.94864 8.00017 5.94864C8.45329 5.94864 8.82065 5.58128 8.82065 5.12813Z",
  fill: "#9CA3AF"
}, null, -1)

import SvgWrapper from '@/components/ui/icons/SvgWrapper.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'IconInfoCircle',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SvgWrapper, {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }))
}
}

})